import { TFunction } from "i18next";

export const getGermanTranslatedText = (
  errorMessage: string,
  t: TFunction
): string => {
  const errorDescriptionArray = errorMessage.trim().split(".");
  const translatedError: string[] = errorDescriptionArray.map((err) => {
    const trimmedError = err.trim();
    if (!trimmedError) return "";

    const errorWithDelimiter = err.trim() + ".";

    return t(errorWithDelimiter);
  });
  return translatedError.join(" ");
};
